<template>
    <div v-if="showModal" class="modal-container">
      <div class="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-40"></div>

      <div class=" modal-content w-[550px] relative bg-white m-auto flex-col flex rounded-lg z-50">

        <div  class="w-full border-b-[1px] mb-4 px-6 py-4">
          <h2 class="text-[18px] text-grayDark font-bold">{{ modalTitle }}</h2>        
        </div>

        <form @submit.prevent="submitModal" class="overflow-y-auto px-6">
          <div class="mb-4 space-y-4">
            <div>
              <label class="block text-[13px] font-medium text-grayDark">Select User</label>
              <select v-if="!loading" v-model="selectedUserId" placeholder="Select user" class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" required>
                <option v-for="user in users" :key="user.user_id" :value="user.user_id">
                  {{ user.first_name }} ({{ user.email }})
                </option>
              </select>
            </div>

            <div>
              <label class="block text-[13px] font-medium text-grayDark">Industry</label>
              <input v-model="newManager.industry" type="text" class="mt-1 block w-full px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9]" required />
            </div>            
          </div>

          <div class="flex justify-end mb-4 text-[14px]">
            <button type="button" class="mr-4 py-2 px-4 bg-primaryLight border border-grayLight text-grayDark rounded" @click="closeModal">Cancel</button>
            <button type="submit" class="flex items-center  gap-2 py-2 px-4 bg-primaryDarkBg w-[146px] h-[42px] text-white rounded">              
              <img src="@/assets/dashboard/add.svg" alt="User icon" class="h-4">
              Add manager
            </button>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import apiClient from '@/axios'


  
  export default {
    name: 'AssignRoleModal',
    components: { 
    },    
    props: {
      showModal: {
        type: Boolean,
        required: true
      }
    },

    data() {
      return {
        loading:false,
        users: [],
        selectedUserId: null,
        selectedRole: 'user',
        modalTitle: 'Add manager',
        newManager: {
          contact_email: '',
          contact_name: '',
          industry: '',
        },
      }
    },
    watch: {
      showModal(newVal) {
        if (newVal) {
          this.fetchManagers();
          this.fetchUsers;
        }
      }
    },
    computed: {
      isAdmin() {
        return this.$store.getters.isAdmin;
      },
      isManager() {
        return this.$store.getters.isManager;
      },
      isTalent() {
        return this.$store.getters.isTalent;
      },
    },
    methods: {
      async fetchUsers() {
        this.loading = true;
        try {
          if (this.isAdmin) {
            const response = await apiClient.get('/web/users'); // Fetch users
            this.users = response.data.data || response.data; // Adjust based on response structure
            console.log('Users fetched:', this.users);            
          }
        } catch (error) {
          console.error('Error fetching users:', error);
        } finally {
            this.loading = false; // Stop loading
          }
      },
      async fetchManagers() {
        this.loading = true;
      try {
        if (this.isAdmin) {
          const response = await apiClient.get('/web/managers');
          // Log the entire response to inspect structure
          console.log('Full API Response:', response);  
          this.managers = response.data.data; 
          console.log('Managers data:', this.managers); // Log the final managers data
        }
      } catch (error) {
        console.error('Error fetching managers or their data:', error);
        console.error('Error response data:', error.response ? error.response.data : 'No response');
      } finally {
        this.loading = false; // Stop showing the loader once data is fetched
      }
    },

      closeModal() {
        this.$emit('close')
        this.clearErrorMessage();
      },
      async submitModal() {
        try {
          // Find the selected user from the users list
          const selectedUser = this.users.find(user => user.user_id === this.selectedUserId);

          if (!selectedUser) {
            throw new Error("Selected user not found.");
          }

          // Construct the manager payload
          this.newManager = {
            contact_name: `${selectedUser.first_name} ${selectedUser.last_name}`,
            contact_email: selectedUser.email,
            industry: this.newManager.industry,
          };

          const response = await apiClient.post('/web/managers', this.newManager);
          console.log('Manager created:', response.data);

          this.$toast.success('Manager created successfully!');
          this.$emit('role-assigned', 'Role assigned successfully!');
          this.$emit('close');
          this.fetchManagers();
        } catch (error) {
          console.error('Error creating manager:', error);
          this.$toast.error(error.response?.data?.message || 'An error occurred');
        }
      },
      clearErrorMessage() {
        // Clearing moved to toast
      },
      
    },
 
    created() {
      this.fetchUsers()
      this.fetchManagers()
    }
  }
  </script>
  
  <style scoped>
    .modal-container {
      display: flex;
      align-items: center;
      justify-content: center;
      position: fixed;
      inset: 0;
      z-index: 50;
    }
  .smoke-light {
    background-color: rgba(0, 0, 0, 0.5);
  }
  .modal-content {
    position: relative;
    z-index: 60;
  }
  </style>
  